import ArrowBack from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import * as React from 'react';
import { teceoGrayPrimary } from '../../../../Theme';
import useWidth from '../../../../components/Hooks/useWidth';
import useTeceoStyles from '../../../../useTeceoStyles';
import { useChatModalContext } from '../../contexts/chatModal/ChatModal.context';

type ClassesKeys = 'wrapper';

type ChatHeaderTemplateProps = {
  children: React.ReactNode;
  onClose?: () => void;
  action?: React.ReactNode;
  onClickGoBack?: () => void;
  classes?: Record<ClassesKeys, string>;
};

export const CHAT_HEADER_MAX_HEIGHT = '70px';

const ChatHeaderTemplate = ({
  action,
  onClose,
  children,
  onClickGoBack,
  classes,
}: ChatHeaderTemplateProps) => {
  const { mobileWidth } = useWidth();

  const { close } = useChatModalContext();

  return (
    <Box
      className={classes?.wrapper}
      sx={{
        px: '20px',
        py: '16px',
        maxHeight: CHAT_HEADER_MAX_HEIGHT,
      }}
    >
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Grid size={action ? 6 : 8}>
          <Grid
            container
            wrap="nowrap"
            sx={{
              alignItems: 'center',
            }}
          >
            {onClickGoBack && (
              <Box
                sx={{
                  paddingRight: 1,
                }}
              >
                <IconButton size="small" onClick={onClickGoBack}>
                  <ArrowBack fontSize="small" style={{ color: teceoGrayPrimary }} />
                </IconButton>
              </Box>
            )}
            {children}
          </Grid>
        </Grid>

        <Grid>
          <Grid container spacing={1}>
            {action && (
              <Grid>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  {action}
                </Box>
              </Grid>
            )}

            <Grid>
              <IconButton onClick={onClose || close} size={mobileWidth ? 'medium' : 'small'}>
                <CloseIcon style={{ color: teceoGrayPrimary }} />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const Title = ({ text }: { text: string }) => {
  const { classes: teceoClasses } = useTeceoStyles();

  return (
    <Typography color="textPrimary" variant="h4" className={teceoClasses.truncate}>
      {text}
    </Typography>
  );
};

export default { Title, Template: ChatHeaderTemplate };
